export enum ConferenceTypes {
  Free = "Free entry for attendees",
  Paid = "Paid ticket for attendees",
}
